import { PlanOptionsQuery } from '__generated__/PlanOptionsQuery.graphql';
import { CampaignOfferDetails } from 'journey/offersForYou/typings';
import { ProductDetailPromotions } from 'journey/productDetails/typings';
import {
  GalleryProduct,
  GalleryProductPromotions,
} from 'shared/components/ProductGalleryCard/typings';
import { ProductType } from '../../__generated__/DeviceGalleryQuery.graphql';

type PlanPromotion =
  PlanOptionsQuery['response']['relatedPlans']['bundles'][0]['offerDetails'][0]['promotions'];

type OffersForYouPromotion = CampaignOfferDetails['promotions'];

type Promotions =
  | PlanPromotion
  | ProductDetailPromotions
  | GalleryProductPromotions
  | OffersForYouPromotion;

export enum PromotionType {
  CHARACTERISTIC = 'CHARACTERISTIC',
  DEAL = 'DEAL',
  FEATURE = 'FEATURE',
  MARKETING = 'MARKETING',
  ORIGINAL_RRP = 'ORIGINAL_RRP',
}

export function isProductTypeInPromotions(
  product: GalleryProduct,
  productType: ProductType,
): boolean {
  return product?.promotions
    ?.map((promotion) => promotion?.productType)
    .includes(productType);
}

export function getPromotionByType(
  promotions: Promotions,
  promotionType: PromotionType,
): Promotions[0] {
  return promotions?.find(({ productType }) => productType === promotionType);
}

export function getPromotionsByType(
  promotions: Promotions,
  promotionType: PromotionType,
): Promotions {
  return promotions?.filter(({ productType }) => productType === promotionType);
}

export function getPromoDeals(promotions: Promotions): string {
  if (!Array.isArray(promotions)) {
    return null;
  }

  return getPromotionsByType(promotions, PromotionType.DEAL)
    .map(({ name }) => name)
    .join(' & ');
}

export function getFeaturedPromoDeals(promotions: Promotions): string {
  if (!Array.isArray(promotions)) {
    return null;
  }

  return promotions
    ?.filter(
      ({ productType, featured }: GalleryProductPromotions[0]) =>
        productType === PromotionType.DEAL && featured === true,
    )
    .map(({ name }) => name)
    .join(' & ');
}

export function getSavingPriceInPromotions(product: GalleryProduct) {
  return product?.pricePointCredit || product?.savePrice || 0;
}
